<template>
    <div class="p-6 bg-white shadow rounded-lg">
        <h1 class="text-2xl font-bold mb-4">Sync Test Console</h1>
        
        <div class="grid grid-cols-2 gap-4">
            <!-- PULL TEST -->
            <div class="border p-4 rounded">
                <h2 class="text-xl font-semibold mb-2">Test Pull (Server -> Client)</h2>
                <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700">Last Sync Date</label>
                    <input type="datetime-local" v-model="pullDate" class="mt-1 block w-full border-gray-300 rounded-md shadow-sm">
                </div>
                <button @click="testPull" :disabled="loading" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                    Execute Pull
                </button>
                <div v-if="pullResult" class="mt-4 bg-gray-100 p-2 rounded text-xs overflow-auto h-40">
                    <pre>{{ pullResult }}</pre>
                </div>
            </div>

            <!-- PUSH TEST -->
            <div class="border p-4 rounded">
                <h2 class="text-xl font-semibold mb-2">Test Push (Client -> Server)</h2>
                <div class="mb-4">
                     <p class="text-sm text-gray-600 mb-2">Will send a dummy Product with UUID.</p>
                     <button @click="generateDummyData" class="text-blue-500 text-sm underline">Regenerate UUID</button>
                    <pre class="bg-gray-50 p-2 text-xs mt-1">{{ pushPayload }}</pre>
                </div>
                <button @click="testPush" :disabled="loading" class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
                    Execute Push
                </button>
                <div v-if="pushResult" class="mt-4 bg-gray-100 p-2 rounded text-xs overflow-auto h-40">
                    <pre>{{ pushResult }}</pre>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid'; // Assuming uuid is available or use helper

export default {
    layout: Layout,
    data() {
        return {
            loading: false,
            pullDate: '2024-01-01T00:00',
            pullResult: null,
            pushPayload: {
                changes: {
                    products: [
                        {
                            uuid: this.generateUuid(),
                            name: 'Test Product ' + Math.floor(Math.random() * 1000),
                            code: 'TEST-' + Math.floor(Math.random() * 1000),
                            quantity: 10,
                            account_id: 1, // Caution: Hardcoded
                            line_name: 'Test Line'
                        }
                    ]
                }
            },
            pushResult: null
        }
    },
    methods: {
        generateUuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        generateDummyData() {
             this.pushPayload.changes.products[0].uuid = this.generateUuid();
             this.pushPayload.changes.products[0].code = 'TEST-' + Math.floor(Math.random() * 10000);
        },
        async testPull() {
            this.loading = true;
            this.pullResult = 'Loading...';
            try {
                const response = await axios.get('/api/sync/pull', {
                    params: { last_sync_at: this.pullDate }
                });
                this.pullResult = response.data;
            } catch (e) {
                this.pullResult = e.response ? e.response.data : e.message;
            } finally {
                this.loading = false;
            }
        },
        async testPush() {
            this.loading = true;
            this.pushResult = 'Sending...';
            try {
                const response = await axios.post('/api/sync/push', this.pushPayload);
                this.pushResult = response.data;
            } catch (e) {
                this.pushResult = e.response ? e.response.data : e.message;
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
